export const pushToDataLayer = value => {
    console.log("---------------------------- GTM dataLayer ----------------------------")
    console.log(window.dataLayer, value)
  
    if (typeof window.dataLayer !== "undefined" && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(value)
    }
  }